<template>
  <div class="wapper" v-if="getData">
    <div class="box-content" >
      <label class="form-title">入学时间</label>
      <el-date-picker
        class='jm-input135'
        format="yyyy"
        value-format="yyyy"
        v-model.trim="getData.custom_year"
        type="year"
        placeholder="请选择"/>
      <el-date-picker
        class='jm-input135'
        format="MM"
        value-format="MM"
        :disabled="!getData['custom_year']"
        v-model="getData['custom_month']"
        type="month"
        style="margin:0"
        placeholder="请选择"/>
    </div>
    <div class="box-content2">
      <div>
        <div class="yuyan">
          <label class="form-title">现有雅思成绩</label>
          <jm-dict-select
            class="jm-input135"
            clearable
            type="dataset"
            v-model="getData.IELTS.ln_all"
            dict-type="student"
            name="ieltsAll"/>
        </div>
        <div class="yuyan">
          <label class="form-title">L</label>
          <el-input
            class="small"
            v-validate="'between:0,9||testIELTS'"
            name="IELTSL"
            v-model="getData.IELTS.ln_listen"
            placeholder="L"/>
        </div>
        <div class="yuyan">
          <label class="form-title">R</label>
          <el-input
            class="small"
            v-validate="'between:0,9||testIELTS'"
            name="IELTSR"
            v-model="getData.IELTS.ln_read"
            placeholder="R"/>
        </div>
        <div class="yuyan">
          <label class="form-title">S</label>
          <el-input
            class="small"
            v-validate="'between:0,9||testIELTS'"
            name="IELTSS"
            v-model="getData.IELTS.ln_say"
            placeholder="S"/>
        </div>
        <div class="yuyan">
          <label class="form-title">W</label>
          <el-input
            class="small"
            v-validate="'between:0,9||testIELTS'"
            name="IELTSW"
            v-model="getData.IELTS.ln_write"
            placeholder="W"/>
        </div>
        <div class="yuyan">
          <el-checkbox v-model="getData.isukvi">是否UKVI</el-checkbox>
        </div>
      </div>
      <span
        class="errors"
        v-if="errors.has('IELTSL')" >*{{ errors.first('IELTSL') }}</span>
      <span
        class="errors"
        v-if="errors.has('IELTSR')" >*{{ errors.first('IELTSR') }}</span>
      <span
        class="errors"
        v-if="errors.has('IELTSS')" >*{{ errors.first('IELTSS') }}</span>
      <span
        class="errors"
        v-if="errors.has('IELTSW')" >*{{ errors.first('IELTSW') }}</span>
    </div>
    <div class="box-content">
      <label class="form-title">考试时间</label>
      <el-date-picker
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
        v-model="getData.offer_exam_time"
        type="date"
        placeholder="选择日期"/>
    </div>
    <div class="box-content">
      <label class="form-title">预计再考试时间</label>
      <el-date-picker
        v-model="getData.offer_exam_time_again"
        type="date"
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
        placeholder="选择日期"/>
    </div>
    <div class="box-content-all">
      <div class="email">
        <label class="form-title">申请邮箱（*）</label>
        <el-input
          v-model="getData.offer_email"
          placeholder="邮箱用户名"/>
        <el-input
          v-model="getData.offer_email_pass"
          placeholder="邮箱密码"/>
        <el-checkbox v-model="getData.offer_tell_student">是否告知学生</el-checkbox>
      </div>
    </div>
    <div class="box-content">
      <label class="form-title">Argue（*）</label>
      <jm-dict-select
        clearable
        type="dataset"
        v-model="getData.offer_uk_Argue"
        dict-type="student"
        name="isTover"/>
    </div>
    <div class="box-content-all">
      <label class="form-title">拒信备注（*）</label>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2}"
        placeholder="请输入内容"
        v-model="getData.argue_beizhu"/>
    </div>
    <div
      class="box-content-all"
      v-if="offerId">
      <jm-materialClouds
        :title="'上传Argue信'"
        upload-url='/newfib.php/index/base_process/fileuploadOfferSchool'
        :qufen="this.offerId"
        :upload-data="{
          crm_id: this.$route.params.crm_id,
          offer_school_id:this.offerId,
          country_id:30,
          field_name:'offer_uk_Argue',
        }"
      />
    </div>
  </div>
</template>
<script>
import { jmDictSelect } from '@/components/tool';
import materialClouds from '@/pages/student/officials/materialClouds.vue';
import { Validator } from 'vee-validate';

export default {
  data() {
    return {
    };
  },
  props: {
    getData: {
      type: Object,
      default: null
    },
    offerId: {
      type: Number,
    }
  },
  methods: {
    yanzhaqngAll() {
      // 本页验证信息方法
      const dictionary = {
        zh_CN: {
          messages: {
            required: (field) => { return `请输入${field}`; },
            between: (filed, data) => { return `${filed}应该在${data[0]} 到 ${data[1]}之间`; },
            numeric: (filed) => { return `${filed}只能为整数`; },
            decimal: (filed) => { return `${filed}最多一位小数`; }
          },
          attributes: {
            IELTSALL: '雅思成绩',
            IELTSL: '雅思听力成绩',
            IELTSR: '雅思阅读成绩',
            IELTSW: '雅思写作成绩',
            IELTSS: '雅思口语成绩',
            TOEFLAll: '托业成绩',
            TOEFLL: '托业听力成绩',
            TOEFLS: '托业口语成绩',
            TOEFLW: '托业写作成绩',
            TOEFLR: '托业阅读成绩',
            GRE: 'GRE成绩',
            GRES: 'GRE数学成绩',
            GREY: 'GRE语文成绩',
            GREX: 'GRE写作成绩',
            GMAT: 'GMAT成绩'
          }
        }
      };
      Validator.localize(dictionary);
    }
  },
  watch: {
  },
  components: {
    'jm-materialClouds': materialClouds,
    jmDictSelect,
    Validator
  },
  mounted() {
    this.yanzhaqngAll();
  }
};
</script>
<style scoped>
  .btn-group{
    padding: 10px;
    border: 1px solid #ebeef5;
    border-top: none;
    background: #FBFDFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-group a{
    line-height: 34px;
    display: block;
    float: left;
    height:34px;
    padding: 0 16px;
    font-size: 14px;
    border-radius: 4px;
    color: #409EFF;
    border: 1px solid #409EFF;
    margin-left: 8px;
  }
  .btn-group:after{
    display: block;
    content: '';
    clear: both;
    opacity:0;
  }
  .box-content-auto:after{
    display: block;
    content: '';
    clear: both;
    opacity:0;
  }
  .box-content-auto{
    display: flex;
    width: 20%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  .errors{
    color: red;
  }
  .wapper{
    padding:0 20px
  }
  .wapper:after,.box-content2:after,.yuyan:after{
    display: block;
    content: '';
    clear: both;
    opacity:0;
  }
  .box-content-all{
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .email{
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
  }
  .yuyan{
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
  }
  .yuyan .small{
    width: 60px;
  }
  .box-content3{
    width: 40%;
    float: left;
    margin-bottom: 10px;
  }
  .box-content3>div{
    display: flex;
  }
  .form-title{
    margin-right: 6px;
    white-space: nowrap;
  }
  .basic-title{
    cursor: default;
    margin-left: 0;
  }
  .basic-title em{
    display: inline-block;
    width: auto!important;
    float: left;
    height: 31px;
    font-size: 16px;
    line-height: 28px;
    padding: 0 8px;
    border-bottom: 4px solid #3368fa;
  }

</style>
